#import "../fragments/audience-stub-fragment.graphql"

query GetAudiences(
    $limit: Int!
    $archived: Boolean
    $cursor: String
    $sort: AudienceSortType!
    $search: String
    $creatorUserId: String
    $lastUpdatedTime: String
    $audienceTypeFilter: AudienceTypeFilter
) {
    audiences(
        first: $limit
        archived: $archived
        after: $cursor
        sort: $sort
        search: $search
        creatorUserId: $creatorUserId
        modifiedSinceTime: $lastUpdatedTime
        audienceTypeFilter: $audienceTypeFilter
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            cursor
            node {
                ...AudienceStub
            }
        }
    }
}
